<script>
export default {
  data () {
    return {
      r_timer: {},
      d_timer: {}
    }
  },
  methods: {
    async customRecursive (func = () => false, defaultTime = 1000, key) {
      key = key || (new Date()).toJSON()
      let recursive = async () => {
        let time = await func()
        if (time) {
          time = typeof time === 'number' && time > 0 ? time : defaultTime
          this.r_timer[key] = setTimeout(recursive, time)
        }
      }
      await recursive()
    },
    async customDelay (func = () => {}, defaultTime = 1000, key) {
      key = key || (new Date()).toJSON()
      if (this.d_timer[key]) {
        clearTimeout(this.d_timer[key])
      }
      this.d_timer[key] = setTimeout(func, defaultTime)
      return key
    }
  },
  beforeUnmount () {
    [
      Object.values(this.r_timer),
      Object.values(this.d_timer)
    ].forEach(timer => clearTimeout(timer))
  }
}
</script>
